import md5 from "js-md5";
import { Cookie } from "./secure/cookie";
import { DEC } from "./secure/decipher";
import { fetch } from "./secure/rest";
import { deleteCookie, getCookie, setCookie } from "../../lib/utils";

var tk =
    "110000 110110 110010 1100100 1100011 1100010 1100011 111000 101101 1100001 110111 1100001 110110 101101 110100 1100100 111001 1100101 101101 1100001 110010 110011 110110 101101 110100 1100100 1100011 110110 110110 110100 110000 1100101 110101 110000 110000 110000";

export class C {
    regex = /^[a-zA-Z0-9]{8}$/g;
    checkInterval = 60000;

    constructor(opt) {
        this.option = opt; //this.preproc( opt );
        this.entryID = md5(this.option.s.toString());
        this.postID = md5(this.option.p.toString());
        this.callback = () => { };
        this.stopCallback = () => { };
        this.queryString = new Proxy(
            new URLSearchParams(window.location.search),
            {
                get: (searchParams, prop) => {
                    if (prop === "keys") {
                        let paramsKeys = [];
                        for (const key of searchParams.keys()) {
                            paramsKeys.push(key);
                        }
                        return paramsKeys;
                    } else {
                        return searchParams.get(prop);
                    }
                },
            },
        );
    }
    async checkCookie() {
        // let cookie = new Cookie( this.option.c );
        let cookie = getCookie(this.option.c);
        if (!cookie || cookie == "") {
            return false;
        }
        let bin = this.bin();
        let hash = new DEC(bin[0], bin[1]);
        let payload = hash.decrypt(cookie);

        return await this.placeStreamCookie(payload.a);
        return false;
    }

    async checkQueryString(key) {
        const accessCodeHashAndTimestamp = this.queryString[key];
        if (!accessCodeHashAndTimestamp || accessCodeHashAndTimestamp == "") {
            return false;
        }
        const timestamp = parseInt(accessCodeHashAndTimestamp.slice(0, 6), 36);
        const accessCodeHash = accessCodeHashAndTimestamp.slice(6);

        if (accessCodeHash.length !== 64) {
            console.log("Access Code Invalid");
            return false;
        }
        const dateNow = Math.floor(Date.now() / 1000);

        if (dateNow - timestamp > 5 * 60) {
            // if difference bigger than 5 minutes
            console.log("Access Code Link Expired");
            return false;
        }

        let bin = this.bin();
        let hash = new DEC(bin[0], bin[1]);

        let payload = hash.decrypt(accessCodeHash);
        return await this.placeStreamCookie(payload.a);
        return false;
    }

    setCallback(callback) {
        this.callback = callback;
    }

    setStopCallback(stopCallback) {
        this.stopCallback = stopCallback;
    }

    hex2asc(str1) {
        let hex = str1.toString();
        let str = "";
        for (let n = 0; n < hex.length; n += 2) {
            str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
        }
        return str;
    }

    bin() {
        let bin = "";
        tk.split(" ").map((bit) => {
            bin += String.fromCharCode(parseInt(bit, 2));
        });

        let tempstr = new String(this.option.t.replace(bin, ""));
        tempstr = this.hex2asc(tempstr);
        return tempstr
            .replace(":" + this.option.s.toString() + ":" + bin, "")
            .split(":");
    }

    getEngineUrl(jsonUrl) {
        let datapayload = fetch("GET", jsonUrl);
        let bin = this.bin();
        let hash = new DEC(bin[0], bin[1]);
        let url = hash.decrypt2(datapayload["eu"]);
        return url;
    }

    async validate(access_code) {
        let payload = {
            d: this.option.s.toString(), // site id
            a: access_code,
        };
        let bin = this.bin();
        let datapayload = await fetch("GET", this.option.r);
        if (datapayload.status >= 300) {
            return false;
        }
        if (typeof datapayload.data[this.entryID] === "undefined") {
            return false; // invalid site
        }
        let products = datapayload.data[this.entryID];
        if (typeof products[this.postID] === "undefined") {
            return false; // invalid product
        }
        // get the hash keys for the product
        let hashkeys = products[this.postID];

        //console.log("payload");
        //console.log(payload);

        let hash = new DEC(bin[0], bin[1]);
        let encryptID = hash.encrypt(payload);

        let found = false;
        let f_payload = null;

        //console.log("hashKeys", hashkeys);
        //console.log("------>", encryptID);

        if (hashkeys.includes(encryptID)) {
            let hash_index = hashkeys.indexOf(encryptID);
            f_payload = hashkeys[hash_index];
            found = true;
        } else {
            found = false;
        }

        return found;
    }

    async removeStreamCookie() {
        deleteCookie(this.option.c);
    }

    async placeStreamCookie(accessCode, wait = false) {
        let cookieData = this.getPayload(accessCode);
        // let cookie = new Cookie( this.option.c, 0.5, cookieData );
        // cookie.dropCookie( );
        setCookie(this.option.c, cookieData, 0.5);
        if (wait) {
            this.globalTimer = setTimeout(async () => {
                console.log("===  wait access code");
                let ok = await this.startAccessChecking();
                if (!ok) {
                    console.log("stopChecking");
                    this.stopAccessChecking();
                }
            }, this.checkInterval);
            return;
        }
        return await this.startAccessChecking();
    }

    preproc(opt) {
        let p = atob(opt);
        //   return Serialize.unserialize( p, { Options: Options } ); doens't work on safari 9 later
        console.log("-----------> opt", JSON.parse(p));
        return JSON.parse(p);
    }

    getPayload(accessCode) {
        let payload = {
            d: this.option.s.toString(),
            a: accessCode,
        };
        let bin = this.bin();
        let hash = new DEC(bin[0], bin[1]);
        return hash.encrypt(payload);
    }

    /**
     *
     * Note : Cookie validation does not work on locally stored files so please try this on server.
     *
     * @private
     */
    async cookieValidate() {
        //console.log("cookie validate ---->>>");
        // let cookie = new Cookie( this.option.c );
        let cookie = getCookie(this.option.c);

        //console.log("here--1");

        if (!cookie || cookie == "") {
            return true;
        } else {
            //console.log("here--2");
            let bin = this.bin();
            let hash = new DEC(bin[0], bin[1]);
            let payload = hash.decrypt(cookie);

            //console.log("here--3");

            if (payload.d != this.option.s) {
                return true;
            }

            let found = await this.validate(payload.a);
            //console.log("found=", found);

            //console.log("here--6");
            if (!found) {
                return true;
            }
        }

        //console.log("here--7");

        return false;
    }

    async startAccessChecker() {
        // check cookie exists
        let accessDenied = await this.cookieValidate();
        console.log("--> access_denied_state", accessDenied);

        if (accessDenied) {
            this.stopAccessChecking();
        }
        return;
    }

    async startAccessChecking() {
        if (this.globalTimer) {
            clearInterval(this.globalTimer);
        }

        var access_denied = await this.cookieValidate();
        console.log("access_denied_state", access_denied);

        if (access_denied) {
            let cookie = new Cookie(this.option.c);
            cookie.deleteCookie();
            return false;
        }

        this.callback();
        this.globalTimer = setInterval(() => {
            console.log("===checking");
            this.startAccessChecker();
        }, this.checkInterval);

        return true;
    }

    stopAccessChecking() {
        console.log("=== stopAccessChecking");
        if (this.globalTimer) {
            clearInterval(this.globalTimer);
        }
        let cookie = new Cookie(this.option.c);
        cookie.deleteCookie();
        this.stopCallback();
    }
}
